import axios from '../../utils/axios';

export default function fetchLGBillsCount(adminId, params = {}) {
    return (
        axios.get('/admin/'+adminId+'/allLGBillsCount', {params})
    )
}
